import { Box, List, ListItem, Typography } from "@mui/joy";
import { QCSectionResult } from "../../types/qcTypes";

interface QCSectionErrorNoticeProps {
  sections: QCSectionResult[];
}

const QCSectionErrorNotice: React.FC<QCSectionErrorNoticeProps> = ({
  sections,
}) => (
  <Box>
    <Typography level="title-sm">
      Quality check could not fully process these sections:
    </Typography>
    <List marker="disc" size="sm" sx={{ pl: 2, my: 0.75 }}>
      {sections.map((section) => (
        <ListItem key={section.sectionIndex}>{section.sectionTitle}</ListItem>
      ))}
    </List>
  </Box>
);

export default QCSectionErrorNotice;
